import isString from "lodash/isString";
import isArray from "lodash/isArray";
import isFunction from "lodash/isFunction";
import isObject from "lodash/isObject";
import random from "lodash/random";
import loadjs from "loadjs";
import WeaLocaleProvider from "../wea-locale-provider";
import * as caUtil from "@callApi";

const getLabel = WeaLocaleProvider.getLabel;
const callApi = caUtil.callApi;

class EventRegister {
  constructor() {
    this.timeMark = "";
    this.loadjs = loadjs;
    this.list = {};
    this.startListInner = this.startListInner.bind(this);
  }
  register(name, cof) {
    this.list[name] = cof;
  }

  registerList(name, cof) {
    if (Object.prototype.toString.call(this.list[name]) === "[object Array]") {
      this.list[name].push(cof);
    } else {
      this.list[name] = [];
      this.list[name].push(cof);
    }
  }
  startList(name, params, successCb, failedCb) {
    loadjs.isDefined("devModuleCustom")
      ? // ? loadjs.ready(
        //     "devModuleCustom",
        //     this.startListInner.bind(this, name, params, successCb, failedCb)
        //   )
        this.startListInner(name, params, successCb, failedCb)
      : loadjs(
          [
            (window.ecologyContentPath || "") +
              "/cloudstore/config/devStatic/devModuleCustom.js?v=" +
              new Date().getTime(),
            "css!" +
              (window.ecologyContentPath || "") +
              "/cloudstore/config/devStatic/devModuleStyle.css?v=" +
              new Date().getTime()
          ],
          "devModuleCustom",
          {
            success: () => {
              this.startListInner(name, params, successCb, failedCb);
            },
            error: () => {
              this.startListInner(name, params, successCb, failedCb);
            }
          }
        );
  }

  startListInner(name, params, successCb, failedCb) {
    let sCb = successCb;
    let fCb = failedCb;
    if (isFunction(params)) {
      sCb = params;
      fCb = successCb;
    }
    if (Object.prototype.toString.call(this.list[name]) === "[object Array]") {
      const runItem = item => {
        if (item.fn && isFunction(item.fn)) {
          return window.Promise.try(() => {
            if (isObject(params)) {
              return item.fn(params);
            } else {
              return item.fn();
            }
          })
            .then((...args) => {
              item.callback && item.callback(...args);
            })
            .catch((...args) => {
              isFunction(fCb) && fCb(...args);
            });
        } else {
          return new Promise((rs, rj) => {
            console && console.error("run list item fail", item);
            rs();
          });
        }
      };
      var promiseArr = [];
      for (let index = 0; index < this.list[name].length; index++) {
        const element = this.list[name][index];
        promiseArr.push(runItem(element));
      }
      Promise.all(promiseArr)
        .then(() => {
          isFunction(sCb) && sCb();
        })
        .catch(reason => {
          isFunction(fCb) && fCb(...reason);
        });
    } else {
      if (name && isString(name)) {
        if (this.list[name]) {
          this.start(name, params, successCb, failedCb);
        } else {
          isFunction(sCb) && sCb();
        }
      } else {
        isFunction(sCb) && sCb();
      }
    }
  }

  clear() {
    this.list = {};
  }
  getCof() {
    return this.list;
  }
  loadModule(...args) {
    let count = 1;
    let interVal = setInterval(() => {
      if (args && args[0] && this.list[args[0]]) {
        clearInterval(interVal);
      }
      if (count > 1000) clearInterval(interVal);
      this.start(...args);
      count++;
    }, 10);
  }
  start(name, params, successCb, failedCb) {
    let sCb = successCb;
    let fCb = failedCb;
    if (name && isString(name)) {
      let item = this.list[name];
      if (isFunction(params)) {
        sCb = params;
        fCb = successCb;
      }
      const runItem = item => {
        if (item.fn && isFunction(item.fn)) {
          window.Promise.try(() => {
            if (isObject(params)) {
              return item.fn(params);
            } else {
              return item.fn();
            }
          })
            .then((...args) => {
              item.callback && item.callback(...args);
              isFunction(sCb) && sCb(...args);
            })
            .catch((...args) => {
              isFunction(fCb) && fCb(...args);
            });
        }
      };
      if (item) {
        if (item.lib) {
          let buddleId = `${item.libName || random(1000000)}`;
          const libArr = item.lib.map(
            l => `${/\.css[^\/]*$/.test(l) ? "css!" : ""}${l}${this.timeMark}`
          );
          if (!loadjs.isDefined(buddleId)) {
            // 添加每天自动更新缓存功能
            loadjs(libArr, buddleId, {
              async: "async" in item ? item.async : true,
              success: () => {
                runItem(item);
              },
              error: () => {
                let message = item.libName || item.lib;
                message = getLabel(385818, "加载$s失败！！！").replace(
                  /\$s/,
                  message
                );
                fCb && fCb(message);
                console && console.error(message);
              }
            });
          } else {
            loadjs.ready(buddleId, () => {
              runItem(item);
            });
          }
        } else {
          runItem(item);
        }
      }
    }
  }
}

if (!window.eventRegister) {
  window.eventRegister = new EventRegister();
}

// const loadmodule = () => {
//   isArray(window.e9ModuleConfig) &&
//     window.e9ModuleConfig.forEach(cof => {
//       if (cof.name) {
//         window.eventRegister.register(cof.name, {
//           lib: cof.lib,
//           libName: cof.name,
//           fn() {
//             return "success";
//           }
//         });
//       }
//     });
// };

const loadmodule = () => {
  let arr = [];
  if (isArray(window.e9ModuleConfig)) {
    arr = arr.concat(window.e9ModuleConfig);
  }
  if (isArray(window.e9ModuleConfigCustomF)) {
    arr = arr.concat(window.e9ModuleConfigCustomF);
  }
  if (isArray(window.e9ModuleConfigCustomB)) {
    arr = arr.concat(window.e9ModuleConfigCustomB);
  }
  arr.forEach(cof => {
    if (cof.name) {
      window.eventRegister.register(cof.name, {
        lib: cof.lib,
        libName: cof.name,
        fn() {
          return "success";
        }
      });
    }
  });
};

loadmodule();
// loadjs(`/spa/moduleConfig.js?v=${random(1000000)}`, "e9ModuleConfig", () =>
//   loadmodule()
// );

// const loaddevmodule = () => {
//   isArray(window.devModuleConfig) &&
//     window.devModuleConfig.forEach(cof => {
//       if (cof.id) {
//         window.eventRegister.register(cof.id, {
//           lib: cof.lib,
//           libName: cof.name,
//           fn() {
//             return "success";
//           }
//         });
//       }
//     });
// };

// loadjs(
//   ["/cloudstore/config/devStatic/devModuleConfig.js"],
//   "devModuleConfig",
//   () => loaddevmodule()
// );

// callApi("/api/system/componentmanage/queryComponentByComtype").then(data => {
//   if (data.status && data.datas) {
//     data.datas.forEach(cof => {
//       if (cof.id) {
//         var libs = cof.url.split(",");
//         for (let index = 0; index < libs.length; index++) {
//           const element = libs[index];
//           if (
//             window.ecologyContentPath &&
//             !new RegExp(window.ecologyContentPath).test(element)
//           ) {
//             libs[index] = window.ecologyContentPath + element;
//           }
//         }
//         window.eventRegister.register(cof.id, {
//           lib: libs,
//           libName: cof.name,
//           fn() {
//             return "success";
//           }
//         });
//       }
//     });
//     window.e9_registed_coms = true;
//   }
// });

// 根据环境加载配置文件
// var curHost = window.location.hostname;
// var hostArr = ["192.168.7.224", "192.168.1.73", "192.168.1.71"];
// if (hostArr.indexOf(curHost) !== -1) {
//   loadjs(
//     [
//       "/cloudstore/config/devStatic/devModuleCustom-dev.js",
//       "/cloudstore/config/devStatic/devModuleStyle-dev.css"
//     ],
//     "devModuleCustom"
//   );
// } else {

try {
  var defaultDevFiles = [
    (window.ecologyContentPath || "") +
      "/cloudstore/config/devStatic/devModuleCustom.js?v=" +
      new Date().getTime(),
    "css!" +
      (window.ecologyContentPath || "") +
      "/cloudstore/config/devStatic/devModuleStyle.css?v=" +
      new Date().getTime()
  ];
  if (window.ecDevFileConfig && window.ecDevFileConfig.pc) {
    if (window.ecDevFileConfig.pc.global) {
      defaultDevFiles = window.ecDevFileConfig.pc.global;
    }
    if (
      window.ecDevFileConfig.pc.moduleConfig &&
      window.ecDevFileConfig.pc.moduleConfig.length
    ) {
      var moduleConfigList = window.ecDevFileConfig.pc.moduleConfig;
      for (var index = 0; index < moduleConfigList.length; index++) {
        var element = moduleConfigList[index];
        if (window.location.href.search(element.hrefRegex) > 0) {
          defaultDevFiles = defaultDevFiles.concat(element.files);
        }
      }
    }
  }
  loadjs.isDefined("devModuleCustom")
    ? ""
    : loadjs(defaultDevFiles, "devModuleCustom");
} catch (error) {
  window.localStorage["emDebug"] == "1" && alert("devModuleCustom error");
  console && console.log(error);
}
// }



// WEBPACK FOOTER //
// ./ecology9/wea-tools/eventRegister.js